import {
    combineReducers
} from 'redux';

import {
    types
} from 'actions/types';

// Import Reducers
import auth from './auth-reducer';
import availability from './availability-reducer';
import booking from './booking-reducer';
import calendar from '../reducers/calendar-reducer'
import chat from './chat-reducer';
import client from './client-reducer';
import company from './company-reducer'; // eventually merge with providers?
import companyNotification from './company-notification-reducer';
import dialog from './dialog-reducer';
import form from './form-reducer';
import notification from './notification-reducer';
import payment from './payment-reducer';
import photoLog from './photo-log-reducer';
import provider from './provider-reducer';
import screen from './screen-reducer';
import service from './service-reducer';
import router from './router-reducer';
import time from './time-reducer';
import toolbar from './toolbar-reducer';
import video from '../reducers/video-reducer';
import {
    reducer as idle
} from '../utils/reduxIdleMonitor';
import blur from './blur-reducer';
import kpi from './kpi-reducer';

const reducers = {
    idle,
    auth,
    availability,
    blur,
    booking,
    calendar,
    chat,
    client,
    company,
    companyNotification,
    dialog,
    form,
    notification,
    payment,
    router,
    photoLog,
    provider,
    screen,
    service,
    time,
    toolbar,
    video,
    kpi,
};

export default combineReducers(reducers);


// WEBPACK FOOTER //
// ./src/js/reducers/index.js